import {
    posterSharingSharing,
    queryPoster,
    genTicket,
    upload,
    uploadBase64
} from '@/api/sys/poster'
export default {
    namespaced: true,
    actions: {
        posterSharingSharing({ dispatch },
            data
        ) {
            return posterSharingSharing(data)
                .then(res => {
                    return res.data
                })
                .catch(err => {
                    // vm.loading.close()
                    // vm.$alert('缺少参数，请重新打开', '操作提示', {
                    //   confirmButtonText: '确定'
                    // })
                })
        },
        queryPoster({ dispatch },
            data
        ) {
            return queryPoster(data)
                .then(res => {
                    return res.data
                })
                .catch(err => {
                    // vm.loading.close()
                    // vm.$alert('缺少参数，请重新打开', '操作提示', {
                    //   confirmButtonText: '确定'
                    // })
                })
        },
        genTicket({ dispatch },
            data
        ) {
            return genTicket(data)
                .then(res => {
                    return res.data
                })
                .catch(err => {
                    // vm.loading.close()
                    // vm.$alert('缺少参数，请重新打开', '操作提示', {
                    //   confirmButtonText: '确定'
                    // })
                })
        },
        upload({ dispatch },
            data
        ) {
            return upload(data)
                .then(res => {
                    return res.data
                })
                .catch(err => {
                    // vm.loading.close()
                    // vm.$alert('缺少参数，请重新打开', '操作提示', {
                    //   confirmButtonText: '确定'
                    // })
                })
        },
        uploadBase64({ dispatch },
            data
        ) {
            return uploadBase64(data)
                .then(res => {
                    return res.data
                })
                .catch(err => {
                    // vm.loading.close()
                    // vm.$alert('缺少参数，请重新打开', '操作提示', {
                    //   confirmButtonText: '确定'
                    // })
                })
        }
    }
}